module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Regular.da74a456.ttf";